import { useLocation } from "react-router-dom";
import { DOWNLOAD_PDF } from "src/const/common";


const useIsPdfPage = (): boolean => {
    const location = useLocation();
    const isPdfPage = location.pathname.includes(DOWNLOAD_PDF);

    return isPdfPage;
};

export default useIsPdfPage;
